// Placeholders for canned responses: "Hi {{first_name}}, about ticket
// #{{ticket_number}}..." is filled in when the response is inserted, so one
// template reads personally for every customer. Unknown placeholders are left
// as typed so an agent notices and fixes them before sending.
export const TEMPLATE_VARIABLES = [
  'first_name', 'last_name', 'full_name', 'ticket_number', 'ticket_id', 'subject', 'agent_name'
];

// Builds the values for a ticket. `customer_name` on a ticket is the person's
// full name; the first word is used as the first name.
export const templateContext = (ticket, agentName) => {
  const full = String((ticket && ticket.customer_name) || '').trim();
  const [first, ...rest] = full.split(/\s+/).filter(Boolean);
  return {
    first_name: first || 'there',
    last_name: rest.join(' '),
    full_name: full,
    ticket_number: ticket && ticket.ticket_number ? String(ticket.ticket_number) : '',
    ticket_id: (ticket && ticket.ticket_id) || '',
    subject: (ticket && ticket.subject) || '',
    agent_name: agentName || ''
  };
};

export const fillTemplate = (text, context) => String(text || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (match, key) => {
  const value = context[key.toLowerCase()];
  return value ? value : match;
});
